/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BancaDTO
 */
export interface BancaDTO {
    /**
     * 
     * @type {string}
     * @memberof BancaDTO
     */
    descrizioneBreve?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BancaDTO
     */
    abi?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BancaDTO
     */
    cab?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BancaDTO
     */
    iban?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BancaDTO
     */
    sia?: string | null;
}

/**
 * Check if a given object implements the BancaDTO interface.
 */
export function instanceOfBancaDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function BancaDTOFromJSON(json: any): BancaDTO {
    return BancaDTOFromJSONTyped(json, false);
}

export function BancaDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): BancaDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'descrizioneBreve': !exists(json, 'descrizioneBreve') ? undefined : json['descrizioneBreve'],
        'abi': !exists(json, 'abi') ? undefined : json['abi'],
        'cab': !exists(json, 'cab') ? undefined : json['cab'],
        'iban': !exists(json, 'iban') ? undefined : json['iban'],
        'sia': !exists(json, 'sia') ? undefined : json['sia'],
    };
}

export function BancaDTOToJSON(value?: BancaDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'descrizioneBreve': value.descrizioneBreve,
        'abi': value.abi,
        'cab': value.cab,
        'iban': value.iban,
        'sia': value.sia,
    };
}

